import React, { useState, useEffect } from 'react';
import { ip } from './../constants';
import logo from '../space.webp';
import userIcon from './../img/userIcon.png';
import Cookies from 'universal-cookie';
import './Main.css';
import info from './../img/info.png';
import home from './../img/home.png';
import persons from './../img/profile.png';
import car from './../img/car.png';
import company from './../img/company.png';
import crime from './../img/crime.png';
import phoneInterner from './../img/phoneInterner.png';
import ors from './../img/ors.png';
import event from './../img/event.png';
import documents from './../img/document.png';
import weapon from './../img/weapon.png';
import bs from './../img/bs.png';
import headPhone from './../img/headphone.png';
import SearchModel from './models/SearchModel';
import Person from './components/Person';
import Address from './components/Address';
import Company from './components/Company';
import Auto from './components/Auto';
import Contact from './components/Contact';
import Document from './components/Document';
import Gun from './components/Gun';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import { decryptAes, encryptAes, storeKey } from '../crypto-utils';
import Proceedings from './components/Proceedings';
import OPM from './components/OPM';
import Traitor from './components/Traitor';
import BS from './components/BS';
import Kan from './components/Kan';
import { createAddress, createAuto, createBS, createCompany, createContact, createDoc, createGun, createKan, createOPM, createPerson, createProceedings, createTraitor, showError } from './ViewCreator';

const cookies = new Cookies();


function MainView() {
  const [userName, setuserName] = useState("");
  const [count, setCount] = useState(null); // Стан для збереження даних
  const searchModel = new SearchModel();



  const mainSubmit = () => {
    window.location.href = "/main";
  };

  const signoutSubmit = () => {
    cookies.remove('type')
    cookies.remove('login')
    window.location.href = "/";
  };


  const getCount = async (type) => {
    var path = ip + '/api/person/count';
    if (type === 1) {
      path = ip + '/api/address/count'
    } else if (type === 2) {
      path = ip + '/api/auto/count'
    } else if (type === 3) {
      path = ip + '/api/company/count'
    } else if (type === 4) {
      path = ip + '/api/contact/count'
    } else if (type === 5) {
      path = ip + '/api/document/count'
    } else if (type === 6) {
      path = ip + '/api/gun/count'
    } else if (type === 7) {
      path = ip + '/api/proceedings/count'
    } else if (type === 8) {
      path = ip + '/api/opm/count'
    } else if (type === 9) {
      path = ip + '/api/traitor/count'
    } else if (type === 11) {
      path = ip + '/api/bs/count'
    } else if (type === 10) {
      path = ip + '/api/kan/count'
    }
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'Content-type: text/html; charset=win1251' },
      encoding: 'latin1',
      credentials: 'include'
    };
    fetch(path, requestOptions)
      .then()
      .then(response => { return response.arrayBuffer() })
      .then((buffer) => {
        const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
        const text = decoder.decode(buffer);
        try {
          var result = JSON.parse(text);
          Swal.fire({
            title: result.msg,
            //text: "Оновити інформацію?",
            icon: "error",
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: 'ОК',
            denyButtonText: 'Оновити',
            background: '#2B2B2B',
            color: '#FFF'
          }).then((result) => {
          })

        } catch (error) {
          const decryptedText = decryptAes(text);
          var result = JSON.parse(decryptedText);
          storeKey('test_data', result.key);
          setCount('Кількість карток у розділі - ' + result.data);
        }
      })
      .catch(err =>
        console.error(err));
  };

  const changeSearch = (inner) => {
    var a = document.getElementById("items");
    document.getElementById("view").innerHTML = "";
    a.innerHTML = ""
    for (let index = 0; index < inner.length; index++) {
      var z = document.createElement('div'); // is a node
      var vv = document.createElement('div');
      vv.className = "itemAddView"
      z.style.display = "table";
      vv.style.display = "table-cell";
      inner[index].style = "table-cell"
      var vb = document.createElement('div');
      vb.className = "itemInfoButton"
      vb.innerHTML = "<img width=\"100%\" src=\"" + info + "\" style=\"margin-bottom: 3px\"  />"
      if (document.getElementById("Person").style.display == "block") {
        const cl = i => () => {
          sendPerson(i)
        }
        vb.onclick = cl(inner[index].value.id)
      }

      if (document.getElementById("Address").style.display == "block") {
        const cl = i => () => {
          sendAddress(i)
        }
        vb.onclick = cl(inner[index].value.id)
      }

      if (document.getElementById("Auto").style.display == "block") {
        const cl = i => () => {
          sendAuto(i)
        }
        vb.onclick = cl(inner[index].value.id)
      }

      if (document.getElementById("BS").style.display == "block") {
        const cl = i => () => {
          sendBS(i)
        }
        vb.onclick = cl(inner[index].value.id)
      }

      if (document.getElementById("Company").style.display == "block") {
        const cl = i => () => {
          sendCompany(i)
        }
        vb.onclick = cl(inner[index].value.id)
      }

      if (document.getElementById("Contact").style.display == "block") {
        const cl = i => () => {
          sendContact(i)
        }
        vb.onclick = cl(inner[index].value.id)
      }

      if (document.getElementById("Document").style.display == "block") {
        const cl = i => () => {
          sendDocument(i)
        }
        vb.onclick = cl(inner[index].value.id)
      }

      if (document.getElementById("Gun").style.display == "block") {
        const cl = i => () => {
          sendGun(i)
        }
        vb.onclick = cl(inner[index].value.id)
      }

      if (document.getElementById("Kan").style.display == "block") {
        const cl = i => () => {
          sendKan(i)
        }
        vb.onclick = cl(inner[index].value.id)
      }

      if (document.getElementById("OPM").style.display == "block") {
        const cl = i => () => {
          sendOPM(i)
        }
        vb.onclick = cl(inner[index].value.id)
      }

      if (document.getElementById("Proceedings").style.display == "block") {
        const cl = i => () => {
          sendProceedings(i)
        }
        vb.onclick = cl(inner[index].value.id)
      }

      if (document.getElementById("Traitor").style.display == "block") {
        const cl = i => () => {
          sendTraitor(i)
        }
        vb.onclick = cl(inner[index].value.id)
      }

      vv.appendChild(vb)
      z.appendChild(inner[index]);
      z.appendChild(vv);

      a.appendChild(z);

      // a.appendChild(inner[index])

    }
  }

  const sendPerson = (id) => {
    var path = ip + '/api/person/id';
    var bd = encryptAes(id)
    const requestOptions = {
      headers: {
        'Content-Type': 'Content-type: text/html; charset=win1251'
      },
      credentials: 'include',
      uri: path,
      encoding: 'latin1',
      body: bd,
      method: 'POST'
    };
    fetch(path, requestOptions)
      .then()
      .then(response => { return response.arrayBuffer() })
      .then((buffer) => {
        const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
        const text = decoder.decode(buffer);
        try {
          var result = JSON.parse(text);
          showError(result.msg)


        } catch (error) {
          const decryptedText = decryptAes(text);
          var result = JSON.parse(decryptedText);
          storeKey('test_data', result.key);


          var zz = []

          var pers = result.data
          var pe = createPerson(pers)
          zz.push(pe)


          /*if(pers.addresses.length>0){
            var adr = document.createElement('div');
            adr.innerHTML = "<br><hr>Адреси:";
            zz.push(adr)
            for (let index = 0; index < pers.addresses.length; index++) {
                var a = v.createAddressCollapsed(pers.addresses[index],index);
                zz.push(a)
            }
          }*/
          String.prototype.replaceAt = function (index, replacement) {
            return this.substr(0, index) + replacement + this.substr(index + replacement.length);
          }
          var spr = document.createElement('div');
          spr.className = "spravka"

          spr.innerHTML = "<hr><p>" + pers.info.replace(/\r\n/g, "<p>");
          zz.push(spr)

          setView(zz)

        }
      })
  }

  const sendAddress = (id) => {
    var path = ip + '/api/address/id';
    var bd = encryptAes(id)
    const requestOptions = {
      headers: {
        'Content-Type': 'Content-type: text/html; charset=win1251'
      },
      credentials: 'include',
      uri: path,
      encoding: 'latin1',
      body: bd,
      method: 'POST'
    };
    fetch(path, requestOptions)
      .then()
      .then(response => { return response.arrayBuffer() })
      .then((buffer) => {
        const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
        const text = decoder.decode(buffer);
        try {
          var result = JSON.parse(text);
          showError(result.msg)

        } catch (error) {
          const decryptedText = decryptAes(text);
          var result = JSON.parse(decryptedText);
          storeKey('test_data', result.key);

          var zz = []

          var addr = result.data

          zz.push(createAddress(addr))

          String.prototype.replaceAt = function (index, replacement) {
            return this.substr(0, index) + replacement + this.substr(index + replacement.length);
          }
          var spr = document.createElement('div');
          spr.className = "spravka"

          spr.innerHTML = "<hr><p>" + addr.infoAddress.replace(/\r\n/g, "<p>");
          zz.push(spr)

          setView(zz)
        }
      })
  }

  const sendAuto = (id) => {
    var path = ip + '/api/auto/id';
    var bd = encryptAes(id)
    const requestOptions = {
      headers: {
        'Content-Type': 'Content-type: text/html; charset=win1251'
      },
      credentials: 'include',
      uri: path,
      encoding: 'latin1',
      body: bd,
      method: 'POST'
    };
    fetch(path, requestOptions)
      .then()
      .then(response => { return response.arrayBuffer() })
      .then((buffer) => {
        const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
        const text = decoder.decode(buffer);
        try {
          var result = JSON.parse(text);
          showError(result.msg)

        } catch (error) {
          const decryptedText = decryptAes(text);
          var result = JSON.parse(decryptedText);
          storeKey('test_data', result.key);

          var zz = []

          var addr = result.data

          zz.push(createAuto(addr))

          String.prototype.replaceAt = function (index, replacement) {
            return this.substr(0, index) + replacement + this.substr(index + replacement.length);
          }
          var spr = document.createElement('div');
          spr.className = "spravka"

          spr.innerHTML = "<hr><p>" + addr.infoAuto.replace(/\r\n/g, "<p>");
          zz.push(spr)

          setView(zz)
        }
      })
  }
  const sendBS = (id) => {
    var path = ip + '/api/bs/id';
    var bd = encryptAes(id)
    const requestOptions = {
      headers: {
        'Content-Type': 'Content-type: text/html; charset=win1251'
      },
      credentials: 'include',
      uri: path,
      encoding: 'latin1',
      body: bd,
      method: 'POST'
    };
    fetch(path, requestOptions)
      .then()
      .then(response => { return response.arrayBuffer() })
      .then((buffer) => {
        const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
        const text = decoder.decode(buffer);
        try {
          var result = JSON.parse(text);
          showError(result.msg)

        } catch (error) {
          const decryptedText = decryptAes(text);
          var result = JSON.parse(decryptedText);
          storeKey('test_data', result.key);

          var zz = []

          var addr = result.data

          zz.push(createBS(addr))


          setView(zz)
        }
      })
  }

  const sendCompany = (id) => {
    var path = ip + '/api/company/id';
    var bd = encryptAes(id)
    const requestOptions = {
      headers: {
        'Content-Type': 'Content-type: text/html; charset=win1251'
      },
      credentials: 'include',
      uri: path,
      encoding: 'latin1',
      body: bd,
      method: 'POST'
    };
    fetch(path, requestOptions)
      .then()
      .then(response => { return response.arrayBuffer() })
      .then((buffer) => {
        const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
        const text = decoder.decode(buffer);
        try {
          var result = JSON.parse(text);
          showError(result.msg)


        } catch (error) {
          const decryptedText = decryptAes(text);
          var result = JSON.parse(decryptedText);
          storeKey('test_data', result.key);

          var zz = []

          var addr = result.data

          zz.push(createCompany(addr))

          String.prototype.replaceAt = function (index, replacement) {
            return this.substr(0, index) + replacement + this.substr(index + replacement.length);
          }
          var spr = document.createElement('div');
          spr.className = "spravka"

          spr.innerHTML = "<hr><p>" + addr.infoCompany.replace(/\r\n/g, "<p>");
          zz.push(spr)

          setView(zz)
        }
      })
  }

  const sendContact = (id) => {
    var path = ip + '/api/contact/id';
    var bd = encryptAes(id)
    const requestOptions = {
      headers: {
        'Content-Type': 'Content-type: text/html; charset=win1251'
      },
      credentials: 'include',
      uri: path,
      encoding: 'latin1',
      body: bd,
      method: 'POST'
    };
    fetch(path, requestOptions)
      .then()
      .then(response => { return response.arrayBuffer() })
      .then((buffer) => {
        const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
        const text = decoder.decode(buffer);
        try {
          var result = JSON.parse(text);
          showError(result.msg)

        } catch (error) {
          const decryptedText = decryptAes(text);
          var result = JSON.parse(decryptedText);
          storeKey('test_data', result.key);

          var zz = []

          var addr = result.data

          zz.push(createContact(addr))

          setView(zz)
        }
      })
  }

  const sendDocument = (id) => {
    var path = ip + '/api/document/id';
    var bd = encryptAes(id)
    const requestOptions = {
      headers: {
        'Content-Type': 'Content-type: text/html; charset=win1251'
      },
      credentials: 'include',
      uri: path,
      encoding: 'latin1',
      body: bd,
      method: 'POST'
    };
    fetch(path, requestOptions)
      .then()
      .then(response => { return response.arrayBuffer() })
      .then((buffer) => {
        const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
        const text = decoder.decode(buffer);
        try {
          var result = JSON.parse(text);
          showError(result.msg)

        } catch (error) {
          const decryptedText = decryptAes(text);
          var result = JSON.parse(decryptedText);
          storeKey('test_data', result.key);

          var zz = []

          var addr = result.data

          zz.push(createDoc(addr))


          setView(zz)
        }
      })
  }

  const sendGun = (id) => {
    var path = ip + '/api/gun/id';
    var bd = encryptAes(id)
    const requestOptions = {
      headers: {
        'Content-Type': 'Content-type: text/html; charset=win1251'
      },
      credentials: 'include',
      uri: path,
      encoding: 'latin1',
      body: bd,
      method: 'POST'
    };
    fetch(path, requestOptions)
      .then()
      .then(response => { return response.arrayBuffer() })
      .then((buffer) => {
        const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
        const text = decoder.decode(buffer);
        try {
          var result = JSON.parse(text);
          showError(result.msg)
        } catch (error) {
          const decryptedText = decryptAes(text);
          var result = JSON.parse(decryptedText);
          storeKey('test_data', result.key);

          var zz = []

          var addr = result.data

          zz.push(createGun(addr))



          setView(zz)
        }
      })
  }

  const sendKan = (id) => {
    var path = ip + '/api/kan/id';
    var bd = encryptAes(id)
    const requestOptions = {
      headers: {
        'Content-Type': 'Content-type: text/html; charset=win1251'
      },
      credentials: 'include',
      uri: path,
      encoding: 'latin1',
      body: bd,
      method: 'POST'
    };
    fetch(path, requestOptions)
      .then()
      .then(response => { return response.arrayBuffer() })
      .then((buffer) => {
        const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
        const text = decoder.decode(buffer);
        try {
          var result = JSON.parse(text);
          showError(result.msg)

        } catch (error) {
          const decryptedText = decryptAes(text);
          var result = JSON.parse(decryptedText);
          storeKey('test_data', result.key);

          var zz = []

          var addr = result.data

          zz.push(createKan(addr))

          String.prototype.replaceAt = function (index, replacement) {
            return this.substr(0, index) + replacement + this.substr(index + replacement.length);
          }
          var spr = document.createElement('div');
          spr.className = "spravka"

          spr.innerHTML = "<hr><p>" + addr.infoKan.replace(/\r\n/g, "<p>");
          zz.push(spr)

          setView(zz)
        }
      })
  }

  const sendOPM = (id) => {
    var path = ip + '/api/opm/id';
    var bd = encryptAes(id)
    const requestOptions = {
      headers: {
        'Content-Type': 'Content-type: text/html; charset=win1251'
      },
      credentials: 'include',
      uri: path,
      encoding: 'latin1',
      body: bd,
      method: 'POST'
    };
    fetch(path, requestOptions)
      .then()
      .then(response => { return response.arrayBuffer() })
      .then((buffer) => {
        const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
        const text = decoder.decode(buffer);
        try {
          var result = JSON.parse(text);
          showError(result.msg)

        } catch (error) {
          const decryptedText = decryptAes(text);
          var result = JSON.parse(decryptedText);
          storeKey('test_data', result.key);

          var zz = []

          var addr = result.data

          zz.push(createOPM(addr))

          String.prototype.replaceAt = function (index, replacement) {
            return this.substr(0, index) + replacement + this.substr(index + replacement.length);
          }
          var spr = document.createElement('div');
          spr.className = "spravka"

          spr.innerHTML = "<hr><p>" + addr.infoOPM.replace(/\r\n/g, "<p>");
          zz.push(spr)

          setView(zz)
        }
      })
  }

  const sendProceedings = (id) => {
    var path = ip + '/api/proceedings/id';
    var bd = encryptAes(id)
    const requestOptions = {
      headers: {
        'Content-Type': 'Content-type: text/html; charset=win1251'
      },
      credentials: 'include',
      uri: path,
      encoding: 'latin1',
      body: bd,
      method: 'POST'
    };
    fetch(path, requestOptions)
      .then()
      .then(response => { return response.arrayBuffer() })
      .then((buffer) => {
        const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
        const text = decoder.decode(buffer);
        try {
          var result = JSON.parse(text);
          showError(result.msg)

        } catch (error) {
          const decryptedText = decryptAes(text);
          var result = JSON.parse(decryptedText);
          storeKey('test_data', result.key);

          var zz = []

          var addr = result.data

          zz.push(createProceedings(addr))

          setView(zz)
        }
      })
  }

  const sendTraitor = (id) => {
    var path = ip + '/api/traitor/id';
    var bd = encryptAes(id)
    const requestOptions = {
      headers: {
        'Content-Type': 'Content-type: text/html; charset=win1251'
      },
      credentials: 'include',
      uri: path,
      encoding: 'latin1',
      body: bd,
      method: 'POST'
    };
    fetch(path, requestOptions)
      .then()
      .then(response => { return response.arrayBuffer() })
      .then((buffer) => {
        const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
        const text = decoder.decode(buffer);
        try {
          var result = JSON.parse(text);
          showError(result.msg)

        } catch (error) {
          const decryptedText = decryptAes(text);
          var result = JSON.parse(decryptedText);
          storeKey('test_data', result.key);

          var zz = []

          var addr = result.data

          zz.push(createTraitor(addr))

          String.prototype.replaceAt = function (index, replacement) {
            return this.substr(0, index) + replacement + this.substr(index + replacement.length);
          }
          var spr = document.createElement('div');
          spr.className = "spravka"

          spr.innerHTML = "<hr><p>" + addr.infoTraitor.replace(/\r\n/g, "<p>");
          zz.push(spr)

          setView(zz)
        }
      })
  }


  const setView = (inner) => {
    var a = document.getElementById("view");
    a.innerHTML = ""
    for (let index = 0; index < inner.length; index++) {
      a.appendChild(inner[index])
    }
  }

  useEffect(() => {

    getCount(0);
    if (cookies.get('login') != null) {
      setuserName(cookies.get('login'));
    }
  }, []);


  const profileSubmit = () => {
    allHide();
    getCount(0);
    document.getElementById("Person").style.display = "block";
    document.getElementById("personsB").className = 'panelButtonActive'
  }

  const homeSubmit = () => {
    allHide();
    getCount(1);
    document.getElementById("Address").style.display = "block";
    document.getElementById("homeB").className = 'panelButtonActive'
  }

  const carSubmit = () => {
    allHide();
    getCount(2);
    document.getElementById("Auto").style.display = "block";
    document.getElementById("carB").className = 'panelButtonActive'
  }

  const companySubmit = () => {
    allHide();
    getCount(3);
    document.getElementById("Company").style.display = "block";
    document.getElementById("companyB").className = 'panelButtonActive'
  }

  const phoneInternerSubmit = () => {
    allHide();
    getCount(4);
    document.getElementById("Contact").style.display = "block";
    document.getElementById("phoneInternerB").className = 'panelButtonActive'
  }

  const documentsSubmit = () => {
    allHide();
    getCount(5);
    document.getElementById("Document").style.display = "block";
    document.getElementById("documentsB").className = 'panelButtonActive'
  }

  const weaponSubmit = () => {
    allHide();
    getCount(6);
    document.getElementById("Gun").style.display = "block";
    document.getElementById("weaponB").className = 'panelButtonActive'
  }

  const orsSubmit = () => {
    allHide();
    getCount(7);
    document.getElementById("Proceedings").style.display = "block";
    document.getElementById("orsB").className = 'panelButtonActive'
  }

  const eventSubmit = () => {
    allHide();
    getCount(8);
    document.getElementById("OPM").style.display = "block";
    document.getElementById("eventB").className = 'panelButtonActive'
  }

  const traitorSubmit = () => {
    allHide();
    getCount(9);
    document.getElementById("Traitor").style.display = "block";
    document.getElementById("crimeB").className = 'panelButtonActive'
  }

  const kanzSubmit = () => {
    allHide();
    getCount(10);
    document.getElementById("Kan").style.display = "block";
    document.getElementById("headPhoneB").className = 'panelButtonActive'
  }

  const bsSubmit = () => {
    allHide();
    getCount(11);
    document.getElementById("BS").style.display = "block";
    document.getElementById("bsB").className = 'panelButtonActive'
  }

  const allHide = () => {
    var a = document.getElementsByClassName("menuItems");
    for (let index = 0; index < a.length; index++) {
      a[index].style.display = "none";

    }
    var b = document.getElementsByClassName("panelButtonActive");
    for (let index = 0; index < b.length; index++) {
      b[index].className = 'panelButton'

    }
  }

  return (
    <div className="main">

      <div className="header">
        <img src={logo} className="logo" alt="logo" />
        <div className="title" onClick={mainSubmit}>SPACE</div>
        <div className="subtitle">(search) </div>
        <div className="countTitle">{count}</div>

        {/*<div className = "support">Проводяться технічні роботи</div>*/}




        <div className="signoutConteiner" onClick={signoutSubmit}>
          <div className="signoutButton">Вийти</div>
        </div>
        <div className="userName">{userName}</div>
        <img src={userIcon} className="userIcon" alt="userIcon" />

      </div>

      <div className="panel">

        <button id="personsB" className="panelButtonActive" onClick={profileSubmit} >
          <img src={persons} className="panelImage" />
        </button>
        <button id="homeB" className="panelButton" onClick={homeSubmit} >
          <img src={home} className="panelImage" />
        </button>
        <button id="carB" className="panelButton" onClick={carSubmit} >
          <img src={car} className="panelImage" />
        </button>
        <button id="companyB" className="panelButton" onClick={companySubmit} >
          <img src={company} className="panelImage" />
        </button>
        <button id="phoneInternerB" className="panelButton" onClick={phoneInternerSubmit} >
          <img src={phoneInterner} className="panelImage" />
        </button>
        <button id="documentsB" className="panelButton" onClick={documentsSubmit} >
          <img src={documents} className="panelImage" />
        </button>
        <button id="weaponB" className="panelButton" onClick={weaponSubmit} >
          <img src={weapon} className="panelImage" />
        </button>
        <button id="orsB" className="panelButton" onClick={orsSubmit} >
          <img src={ors} className="panelImage" />
        </button>
        <button id="eventB" className="panelButton" onClick={eventSubmit} >
          <img src={event} className="panelImage" />
        </button>
        <button id="crimeB" className="panelButton" onClick={traitorSubmit} >
          <img src={crime} className="panelImage" />
        </button>
        <button id="headPhoneB" className="panelButton" onClick={kanzSubmit} >
          <img src={headPhone} className="panelImage" />
        </button>
        <button id="bsB" className="panelButton" onClick={bsSubmit} >
          <img src={bs} className="panelImage" />
        </button>
      </div>

      <div className="searchMenu">
        <div id="Person" className="menuItems" style={{ display: "block" }}>
          <Person changeSearch={changeSearch} searchModel={searchModel} setView={setView} />
        </div>
        <div id="Address" className="menuItems" style={{ display: "none" }}>
          <Address changeSearch={changeSearch} searchModel={searchModel} setView={setView} />
        </div>
        <div id="Auto" className="menuItems" style={{ display: "none" }}>
          <Auto changeSearch={changeSearch} searchModel={searchModel} setView={setView} />
        </div>
        <div id="Company" className="menuItems" style={{ display: "none" }}>
          <Company changeSearch={changeSearch} searchModel={searchModel} setView={setView} />
        </div>
        <div id="Contact" className="menuItems" style={{ display: "none" }}>
          <Contact changeSearch={changeSearch} searchModel={searchModel} setView={setView} />
        </div>
        <div id="Document" className="menuItems" style={{ display: "none" }}>
          <Document changeSearch={changeSearch} searchModel={searchModel} setView={setView} />
        </div>
        <div id="Gun" className="menuItems" style={{ display: "none" }}>
          <Gun changeSearch={changeSearch} searchModel={searchModel} setView={setView} />
        </div>
        <div id="Proceedings" className="menuItems" style={{ display: "none" }}>
          <Proceedings changeSearch={changeSearch} searchModel={searchModel} setView={setView} />
        </div>
        <div id="OPM" className="menuItems" style={{ display: "none" }}>
          <OPM changeSearch={changeSearch} searchModel={searchModel} setView={setView} />
        </div>
        <div id="Traitor" className="menuItems" style={{ display: "none" }}>
          <Traitor changeSearch={changeSearch} searchModel={searchModel} setView={setView} />
        </div>
        <div id="BS" className="menuItems" style={{ display: "none" }}>
          <BS changeSearch={changeSearch} searchModel={searchModel} setView={setView} />
        </div>
        <div id="Kan" className="menuItems" style={{ display: "none" }}>
          <Kan changeSearch={changeSearch} searchModel={searchModel} setView={setView} />
        </div>

      </div>

      <table width="100%">
        <tbody>
          <tr>
            <td width="350px">

            </td>
            <td width="600px" >

              <div id="items">

              </div>



            </td>
            <td id="tdline">
              <div id="line">

              </div>
            </td>
            <td width="*">
              <div id="view">

              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default MainView;
// 